/** "Pobierz PDF" of an invoice: the server names the file (`faktura-FV-1-11-2026.pdf`); an issued invoice gives its stored PDF. */
export function downloadInvoicePdf(invoiceId: string) {
  const a = document.createElement('a');
  a.href = `/api/invoices/${invoiceId}/pdf`;
  a.download = '';
  document.body.append(a);
  a.click();
  a.remove();
}

/** „Pobierz UPO”: KSeF's receipt of the invoice (the server names the file `UPO-FV-1-11-2026.xml`). */
export const upoUrl = (invoiceId: string) => `/api/invoices/${invoiceId}/upo`;

export const EMAIL_STATUS_LABELS = { queued: 'w kolejce', sent: 'wysłano', failed: 'błąd – wyślij ponownie', no_smtp: 'nie wysłano — brak serwera poczty' } as const;
